export default "__VITE_ASSET__DoejPYA6__"